import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  max-height: 531px;
  background-color: ${theme.colors.neutral.white};
`

export const Summary = styled.span`
  color: ${theme.colors.neutral.medium};
  font-size: ${theme.typography.sizes.xs};
`

export const DataWrap = styled.div`
  span {
    color: ${theme.colors.alert.danger[30]};
  }
`
